import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { Observable } from 'rxjs';
import { LocalExecutionUrlModel } from '../Models/local-execution-url-model';

@Injectable({ providedIn: 'root'})
export class UserService {
  constructor(public rest: RestService) { }
  public  getProjects(){
    return this.rest.get('project',null);
  }  

  public getReviewersByProjectId(projectId){
    return this.rest.get('getReviewersByProjectId', projectId);
  }

  public getLocalExecutionUrls(projectId, type): Observable<LocalExecutionUrlModel[]> {
    return this.rest.get('getLocalExecutionUrls', projectId, type);
  }

  public isAdmin(){
    return this.rest.get('isAdmin',null);
  }

  public checkUserQaRole(){
    return this.rest.get('isUserQA', null);
  }

}
